module.exports = __webpack_public_path__ + "static/img/Water pollution-01.ead31a4f.jpg";